import { render, staticRenderFns } from "./MidiaView.vue?vue&type=template&id=6baa7e46&scoped=true"
import script from "./MidiaView.vue?vue&type=script&lang=js"
export * from "./MidiaView.vue?vue&type=script&lang=js"
import style0 from "./MidiaView.vue?vue&type=style&index=0&id=6baa7e46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baa7e46",
  null
  
)

export default component.exports